import React from 'react';
import Link from 'next/link';
import BlogCard from '../Blog/BlogCard';
import FadeInAnimation from '../Common/FadeInAnimation';
import { useTranslations } from '../../locales/useTranslations';

const ManagedServicesBlogPosts = ({
  posts,
  badgeKey,
  titleKey,
  subtitleKey,
  ctaKey,
}) => {
  const { t } = useTranslations();

  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <section className="ms-section ms-section--blog">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t(badgeKey)}</span>
          <h2 className="ms-section__title">{t(titleKey)}</h2>
          <p className="ms-section__lead ms-section__lead--center">{t(subtitleKey)}</p>
        </div>
        <div className="row ms-blog-row">
          {posts.map((post, index) => (
            <div key={post.slug || post.id} className="col-lg-4 col-md-6 mb-4 d-flex">
              <FadeInAnimation direction="up" delay={80 + index * 60} style={{ display: 'flex', width: '100%' }}>
                <BlogCard post={post} />
              </FadeInAnimation>
            </div>
          ))}
        </div>
        <div className="ms-blog__footer">
          <Link href="/blog/" className="ms-header__btn-primary">
            {t(ctaKey)}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ManagedServicesBlogPosts;
